import { janooApi } from "./../config";

const api_wp_ajax_key = process.env.VUE_APP_WP_AJAX_API_KEY
const username = process.env.VUE_APP_WP_USER
const application_password = process.env.VUE_APP_WP_PWD
const janoo_api_url_v1 = process.env.VUE_APP_API_JANOO_URL

export default {
  getBillItems(params) {
    console.error('DEPRECATED METHOD! USE NODEJS SERVICE INSTEAD!')

  },
  setBillItemAgent(agent_data, billItemID, userID) {
    return janooApi.get("/meta_data", {
      //change meta_value by get_meta=true    to retrieve post metadata
      //change meta_value by delete_meta=true to remove post metadata
      params: { meta_key: 'agent_data', api_key: api_wp_ajax_key, post_id: billItemID, meta_value: agent_data, user_id: userID }
    })
  },
  getUserProductsList(userUuid) {
    try {
      if (undefined == userUuid) {
        // TODO: use store.state from @/store instead...
        userUuid = JSON.parse(localStorage.getItem('cakeuserdata')).user.uuid || JSON.parse(localStorage.getItem('cakeuserdata')).place.janooUserUuid
      }
    } catch (error) {
      console.error('get_vendor_pois', error);
    }
    return this.getAjax("GET", "get_vendor_pois", userUuid)
  },
  //TODO: fazer a chamada via axios!!! com o janooApi
  getAjax(protocol, endpoint, bocapio_key, postData) {
    return jQuery.ajax({
      type: protocol,
      url: `${janoo_api_url_v1}${endpoint}?api_key=${api_wp_ajax_key}&bocapio_key=${bocapio_key}`,
      beforeSend: function (xhr) {
        let token = btoa(username + ':' + application_password)
        xhr.setRequestHeader('Authorization', 'Basic ' + token)
      },
    });
  }
};
